// Form module - handles form interactions
// Password toggle, form validation, etc.

class Form {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    this.initPasswordToggle();
  }

  // Password visibility toggle
  initPasswordToggle() {
    const toggleButtons = this.element.querySelectorAll('.form-password-toggle');
    
    toggleButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const input = button.closest('.form-input-wrapper').querySelector('input[type="password"], input[type="text"]');
        
        if (input) {
          const icon = button.querySelector('i');
          
          if (input.type === 'password') {
            input.type = 'text';
            if (icon) {
              icon.classList.remove('fa-eye-slash');
              icon.classList.add('fa-eye');
            }
          } else {
            input.type = 'password';
            if (icon) {
              icon.classList.remove('fa-eye');
              icon.classList.add('fa-eye-slash');
            }
          }
        }
      });
    });
  }
}

// Auto-initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.register-form, form');
  forms.forEach(form => {
    new Form(form);
  });
});

export default Form;

